import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class TextInput extends PureComponent{

	static propTypes = {
		name: PropTypes.string.isRequired,
		label: PropTypes.string,
		value: PropTypes.string,
		errorMessage: PropTypes.string,
		className: PropTypes.string,
		type: PropTypes.string,
		icon: PropTypes.string,
		id: PropTypes.string
	}

	static defaultProps = {
		type: 'text',
		className: ''
	}

	static renderForForm({input, meta: { touched, error }, ...custom }){
		return (
			<TextInput
				errorMessage={touched && error ? error : undefined}
				{...input}
				{...custom}
			/>
		)
	}

	render(){
		const {icon, label, name, type, className, value, id, errorMessage, ...restProps} = this.props

		const inputId = id ? id : `input_${name}`

		const isInputGroup = !!icon

		const input = <input
			id={inputId}
			name={name}
			type={type}
			className={`form-control ${className}`}
			value={value}

			{...restProps}
		/>

		const errorMessageComponent = errorMessage ? <span className="help-block">{errorMessage}</span> : undefined

		return (
			<div className={classNames("form-group", {'has-error': !!errorMessage})}>
				<If condition={label}>
					<label htmlFor={inputId}>{label}</label>
				</If>
				<Choose>
					<When condition={isInputGroup}>
						<div className="input-group">
							<div className="input-group-addon">
								<If condition={icon}>
									<div className={`glyphicon glyphicon-${this.props.icon}`}></div>
								</If>
							</div>
							{input}
						</div>
					</When>
					<Otherwise>
						{input}
					</Otherwise>
				</Choose>
				{errorMessageComponent}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./client/components/forms/TextInput.js